/**
  * @license
  * Copyright 2022 Google LLC
  * SPDX-License-Identifier: Apache-2.0
  */
 import {css} from 'lit';
 export const styles = css`:host{position:relative;display:flex;flex-direction:column}/*# sourceMappingURL=sub-menu-styles.css.map */
`;
 